var React = require('react');

function SlashesLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M71 0L152.743 141H194L112.257 0H71Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M-11 0L70.7426 141H112L30.2574 0H-11Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M236 0L317.743 141H359L277.257 0H236Z","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M153 0L234.743 141H276L194.257 0H153Z","key":3}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30 141H-11.3099L-31 107.108V36L30 141Z","key":4})]);
}

SlashesLeftInline.defaultProps = {"width":"359","height":"141","viewBox":"0 0 359 141","fill":"none"};

module.exports = SlashesLeftInline;

SlashesLeftInline.default = SlashesLeftInline;
